export default __webpack_public_path__ + "static/media/plotigo-logo.8dd899f2.svg";